/**
 * Loader2 — reemplazo 1:1 del spinner de lucide por el disco olímpico ONOR
 * (loader oficial de la identidad v2.1). Acepta las mismas clases que se usaban
 * con el spinner (`w-4 h-4 animate-spin text-primary`), así que el cambio es
 * transparente para los 60+ archivos que lo importan.
 */
const Loader2 = ({ className = '', ...rest }) => (
  <img
    src="/brand/disc.webp"
    alt=""
    aria-hidden="true"
    draggable="false"
    className={`onor-disc ${className}`}
    {...rest}
  />
);

export default Loader2;
